import React, { useCallback } from "react";

import { isNumber } from '@cayuse/shared-react.utils.type-checks';

import styles from "./styles.css";

const handlePercentInputChange = e => {
	const value = e.target.value;
	// strips all non-numbers + converts number string to number ("5asdf9.6%" -> 596)
	let int = +(value.replace(/\D/g,""));
	// if the int is over 100, reduce it down a power (596 -> 59)
	if (int > 100) {
		int = Math.floor(int / 10);
	}
	// converts new int into percent string
	const newValue = `${int}%`;
	// get new index of cursor
	const newSelectionIndex = newValue.indexOf("%");
	// change tag value, so setting selection range actually works
	e.target.value = newValue;
	// moves typing cursor to specified location (just before the %)
	e.target.setSelectionRange(newSelectionIndex, newSelectionIndex);

	// return parsed integer value
	return int;
};

const PercentTextInput = ({ onChange, value, className, setTouched, ...props }) => {
	const handleChange = useCallback(event => {
		const newValue = handlePercentInputChange(event);
		onChange && onChange(newValue, event);
	}, [ onChange ]);

	const handleFocus = useCallback(event => {
		setTouched(true);
	}, [ onChange ]);

	return (
		<input
			{...props}
			type="text"
			className={`${className || ""} ${styles.percentInput}`}
			value={isNumber(value) ? `${value}%` : ""}
			placeholder="%"
			onChange={handleChange}
			onFocus={handleFocus}
		/>
	);
};

export default PercentTextInput;
